import { render, staticRenderFns } from "./tel-number-field.html?vue&type=template&id=a5925d14&"
import script from "./tel-number-field.js?vue&type=script&lang=js&"
export * from "./tel-number-field.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports